import React from 'react'
import AnalyticsBox from '../../../../../../ProjectManager/Influencer/AuthenticationsPageParts/OverviewParts/AnalyticsBox'
import CampaignInfluencerProfileDetails from '../../../../../../Shared/CampaignInfluencerSidebar/CampaignInfluencerProfileDetails'

export default function ProfileDetails({ auth }) {
  return (
    <CampaignInfluencerProfileDetails
      auth={auth}
      AnalyticsBoxComponent={AnalyticsBox}
    />
  )
}